import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { saveAs } from 'file-saver';

const getTokenFromLocalStorage = () => {
  const token = localStorage.getItem("token");
  return token;
};
const baseURL = process.env.REACT_APP_API_URL
export const insuranceAPI = createApi({
  reducerPath: "insuranceClaimAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = getTokenFromLocalStorage();
      if (token) {
        // include token in req header
        headers.set("authorization", `Bearer ${token}`);
        return headers;
      }
    },
  }),
  tagTypes: ["Users", "Group"],
  endpoints: (build) => ({
    getMembers: build.mutation({
      query: (body) => ({
        url: `members/get-paginate-members`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getGroups: build.mutation({
      query: (body) => ({
        url: `groups/get-paginate-groups`,
        method: 'POST',
        body
      }),
    }),
    getInvocies: build.mutation({
      query: (body) => ({
        url: `invoices/get-paginate-invoices`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getCommunications: build.mutation({
      query: (body) => ({
        url: `member-communications/get-paginate-communications`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getLicenses: build.query({
      query: ({ id, licenseTypeId }) => ({
        url: licenseTypeId ? `licenses/license/${id}?licenseType=${licenseTypeId}` : `licenses/license/${id}?licenseType=0`,
      }),
    }),
    getPayments: build.mutation({
      query: (body) => ({
        url: `payments/get-paginate-payments`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getRefunds: build.mutation({
      query: (body) => ({
        url: `refunds/get-paginate-refunds`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getPremiums: build.mutation({
      query: (body) => ({
        url: `premiums/get-paginate-premiums`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message || response.data?.title || response.status,
        };
      },
    }),
    getMemberById: build.query({
      query: (id) => ({
        url: `/members/member?id=${id}`,
      }),
    }),
    getLastBody: build.query({
      query: () => ({
        url: `/member-communications/last-body`,
      }),
    }),
    updateMember: build.mutation({
      query: (body) => ({
        url: `/members/member`,
        method: 'PUT',
        body
      }),

      // async onQueryStarted(value, { dispatch, queryFulfilled }) {
      //   try {
      //     dispatch(
      //       insuranceClaimAPI.util.updateQueryData(
      //         "getMemberById",
      //         value.id,
      //         (draft) => {
      //           console.log(draft);
      //           Object.assign(draft, value); 
      //         }
      //       )
      //     );
      //   } catch (e) {
      //     console.error(e);
      //   }
      // },
    }),
    closeInvoice: build.mutation({
      query: (body) => ({
        url: `/invoices/close-invoice`,
        method: 'PUT',
        body
      }),
    }),
    createMember: build.mutation({
      query: (body) => ({
        url: `/members/member`,
        method: 'POST',
        body
      }),

    }),
    deleteMember: build.mutation({
      query: (id) => ({
        url: `/members/member`,
        method: 'DELETE',
        params: { id }
      }),

    }),
    getAssessments: build.mutation({
      query: (body) => ({
        url: `/assessments/get-paginate-assessments`,
        method: 'POST',
        body
      }),
    }),
    getAssessmentsTitle: build.query({
      query: (id) => ({
        url: `/assessments/assessment-dropdown`,
      }),
    }),
    getInsolvents: build.mutation({
      query: (body) => ({
        url: `insolvents/get-paginate-insolvents`,
        method: 'POST',
        body
      }),
      transformResponse: (response) => {
        response.assesments.forEach(item => item.id = item.callId)
        return response;
      },
    }),
    createAssessmentClassA: build.mutation({
      query: (body) => ({
        url: `/assessments/create-assessment-class-a`,
        method: 'POST',
        body
      }),
    }),
    createAssessmentClassB: build.mutation({
      query: (body) => ({
        url: `/assessments/create-assessment-class-b`,
        method: 'POST',
        body
      }),
    }),
    updateAssessmentClassA: build.mutation({
      query: (body) => ({
        url: `/assessments/update-assessment-class-a`,
        method: 'POST',
        body
      }),
    }),
    updateAssessmentClassB: build.mutation({
      query: (body) => ({
        url: `/assessments/update-assessment-class-b`,
        method: 'POST',
        body
      }),
    }),
    createCommunication: build.mutation({
      query: (body) => ({
        url: `/member-communications/communication`,
        method: 'POST',
        body
      }),
    }),
    sendInvoiceEmail: build.mutation({
      query: (body) => ({
        url: `/invoices/send-invoice-email`,
        method: 'POST',
        body
      }),
    }),
    sendCommunicationEmail: build.mutation({
      query: (body) => ({
        url: `/member-communications/send-communication-email`,
        method: 'POST',
        body
      }),
    }),
    printInvoice: build.mutation({
      queryFn: async (body) => {
        try {
          console.debug("[InsuranceService] Printing invoice with body:", body);
          const response = await fetch(
            `${baseURL}invoices/print-invoice`,
            {
              cache: "no-store",
              headers: {
                authorization: `Bearer ${getTokenFromLocalStorage()}`,
                "Content-Type": "application/json",
              },
              method: "POST",
              body: JSON.stringify(body),
            }
          );

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const contentDisposition = response.headers.get("Content-Disposition");
          let filename = "Invoice.pdf";

          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/);
            if (match && match[1]) {
              filename = decodeURIComponent(match[1]);
            }
          }

          console.log("Filename extracted:", filename);

          const blob = await response.blob();
          saveAs(blob, filename);

          return { data: "File downloaded successfully" };
        } catch (e) {
          return { error: e.message };
        }
      },
    }),
    printCommunication: build.mutation({
      queryFn: async (body) => {
        console.log(body);
        try {
          const response = await fetch(
            `${baseURL}member-communications/print-communication`,
            {
              cache: "no-store",
              headers: {
                authorization: `Bearer ${getTokenFromLocalStorage()}`,
                "Content-Type": "application/json",
              },
              method: "POST",
              body: JSON.stringify(body),
            }
          );

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const contentDisposition = response.headers.get("Content-Disposition");
          let filename = "Invoice.pdf";

          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/);
            if (match && match[1]) {
              filename = decodeURIComponent(match[1]);
            }
          }

          console.log("Filename extracted:", filename);

          const blob = await response.blob();
          saveAs(blob, filename);

          return { data: "File downloaded successfully" };
        } catch (e) {
          return { error: e.message };
        }
      },
    }),

    getStates: build.query({
      query: () => ({
        url: `/states/all-states`,
      }),
    }),
    getInvoicesStatuses: build.query({
      query: () => ({
        url: `/invoices/invoice-statuses`,
      }),
    }),
    getInvoicesByMember: build.query({
      query: (id) => ({
        url: `/invoices/get-invoices-by-member-id?id=${id}`,
      }),
    }),
    getPaymentsByMember: build.query({
      query: (id) => ({
        url: `/payments/get-payments-by-member-id?id=${id}`,
      }),
    }),
    getNaicMember: build.query({
      query: (id) => ({
        url: `members/naic-member-dropdown?searchValue=${id}`,
      }),
    }),
    getLicenseTypes: build.query({
      query: (id) => ({
        url: `licenses/licenses/filter`,
      }),
    }),
    getLicenseDropdownTypes: build.query({
      query: (id) => ({
        url: `licenses/licenses`,
      }),
    }),
    getPaginateHistory: build.mutation({
      query: (body) => ({
        url: `/member-history/get-paginate-history`,
        method: 'POST',
        body
      }),
    }),
    addMemberHistoryNote: build.mutation({
      query: (body) => ({
        url: `/member-history/note`,
        method: 'POST',
        body
      }),
    }),
    addLicense: build.mutation({
      query: (body) => ({
        url: `/licenses/license`,
        method: 'POST',
        body
      }),
    }),
    addGroup: build.mutation({
      query: (body) => ({
        url: `/groups/group`,
        method: 'POST',
        body
      }),
    }),
    editGroup: build.mutation({
      query: (body) => ({
        url: `/groups/group`,
        method: 'PUT',
        body
      }),
    }),
    editLicense: build.mutation({
      query: (body) => ({
        url: `/licenses/license`,
        method: 'PUT',
        body
      }),
    }),
    updateInvoiceStatus: build.mutation({
      query: (body) => ({
        url: `/invoices/update-invoice-status`,
        method: 'PUT',
        body
      }),
    }),
    addPayment: build.mutation({
      query: (body) => ({
        url: `payments/payment`,
        method: 'PUT',
        body,
      }),

      transformResponse: (response) => {
        // API returns: 12345
        return {
          paymentId: response,   // normalized response shape
        };
      },

      transformErrorResponse: (response) => {
        return {
          message:
            response.data?.Message ||
            response.data?.title ||
            response.status,
        };
      },
    }),
    // Payment activity history by payment key
    getPaymentHistory: build.query({
      query: (id) => ({
        url: `payments/get-payment-history?id=${id}`,
      }),
      transformResponse: (response) => {
        // Ensure each activity has a stable id field for DataGridPro
        if (Array.isArray(response)) {
          return response.map(act => ({
            ...act,
            id: act.paymentActivityKey || act.id || act.paymentActivityID || act.PaymentActivityKey,
          }));
        }
        return response;
      },
      transformErrorResponse: (response) => ({
        message: response.data?.Message || response.data?.title || response.status,
      })
    }),
    // Fetch invoices currently linked/applied to a specific payment (editing scenario)
    getInvoicesByPayment: build.query({
      query: (paymentId) => ({
        url: `payments/payment-invoices?paymentId=${paymentId}`,
      }),
      transformResponse: (response) => {
        // Ensure each invoice has an id field (backend might use invoiceId)
        if (Array.isArray(response)) {
          return response.map(inv => ({
            ...inv,
            id: inv.id || inv.invoiceId || inv.Id || inv.InvoiceId,
          }));
        }
        return response;
      }
    }),
    deleteLicense: build.mutation({
      query: (id) => ({
        url: `/licenses/license/${id}`,
        method: 'DELETE',
      }),

    }),
    getAffiliates: build.query({
      query: (id) => ({
        url: `groups/members/affiliates/${id}`,
      }),
      transformResponse: (response) => {
        response?.map((item) => {
          item.id = item.naicCode;
        });
        return response;
      },
      providesTags: ['Group'],
    }),
    getGroupDropdown: build.query({
      query: () => ({
        url: `groups/group-dropdown`,
      }),

    }),
    setGroupMembers: build.mutation({
      query: ({ memberId, groupId }) => ({
        url: `groups/members`,
        method: 'POST',
        body: { memberId, groupId: groupId.id }
      }),
      invalidatesTags: ['Group'],
      async onQueryStarted(value, { dispatch, queryFulfilled }) {
        await queryFulfilled;

        try {
          dispatch(
            insuranceAPI.util.updateQueryData("getMemberById", value.memberId, (draft) => {
              const [groupCode, groupName] = value.groupId.codeName.split(" - ").map(s => s.trim());
              draft.groupCode = groupCode
              draft.groupId = value.groupId.id
              draft.groupName = groupName

            })
          );
        } catch (e) {
          console.error("Error in onQueryStarted:", e);
        }
      },
    }),
  }),
});
export const {
  useGetMembersMutation,
  useGetMemberByIdQuery,
  useGetAssessmentsMutation,
  useGetInsolventsMutation,
  useCreateMemberMutation,
  useUpdateMemberMutation,
  useDeleteMemberMutation,
  useGetStatesQuery,
  useGetInvociesMutation,
  useGetPaymentsMutation,
  useGetRefundsMutation,
  useGetPremiumsMutation,
  useGetInvoicesByMemberQuery,
  useGetPaymentsByMemberQuery,
  useGetPaymentHistoryQuery,
  useGetInvoicesStatusesQuery,
  useCreateAssessmentClassAMutation,
  useCreateAssessmentClassBMutation,
  useUpdateAssessmentClassAMutation,
  useUpdateAssessmentClassBMutation,
  useGetAssessmentsTitleQuery,
  useGetNaicMemberQuery,
  useSendInvoiceEmailMutation,
  useSendCommunicationEmailMutation,
  useCloseInvoiceMutation,
  usePrintInvoiceMutation,
  useGetPaginateHistoryMutation,
  useGetCommunicationsMutation,
  useCreateCommunicationMutation,
  usePrintCommunicationMutation,
  useGetLastBodyQuery,
  useAddMemberHistoryNoteMutation,
  useGetLicensesQuery,
  useGetLicenseTypesQuery,
  useAddLicenseMutation,
  useEditLicenseMutation,
  useDeleteLicenseMutation,
  useGetLicenseDropdownTypesQuery,
  useGetGroupsMutation,
  useAddGroupMutation,
  useEditGroupMutation,
  useAddPaymentMutation,
  useGetAffiliatesQuery,
  useUpdateInvoiceStatusMutation,
  useGetGroupDropdownQuery,
  useSetGroupMembersMutation,
  useGetInvoicesByPaymentQuery
} = insuranceAPI;
